import { apiFetch } from './api';

export function listCustomers({ search = '', page = 1, limit = 20, status = '' } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (status) params.set('status', status);
  params.set('page', String(page));
  params.set('limit', String(limit));
  const q = params.toString() ? `?${params.toString()}` : '';
  return apiFetch(`/api/admin/customers${q}`);
}

export function createCustomer(payload) {
  return apiFetch('/api/admin/customers', { method: 'POST', body: payload });
}

export function getCustomer(id) {
  return apiFetch(`/api/admin/customers/${id}`);
}

export function updateCustomer(id, payload) {
  return apiFetch(`/api/admin/customers/${id}`, { method: 'PATCH', body: payload });
}

export function deleteCustomer(id) {
  return apiFetch(`/api/admin/customers/${id}`, { method: 'DELETE' });
}







